import { useEffect } from "react";
export default function Versand() {
    useEffect(() => {
        document.title = "Versand – Tuscher Helmut Betonrohrfallen";
    }, []);
    return (
        <div className="max-w-3xl mx-auto px-4 py-12 text-sm leading-relaxed">
            <h1 className="text-2xl font-semibold mb-6">Versand & Lieferung</h1>

            <h2 className="text-lg font-semibold mt-6 mb-2">Versandgebiet</h2>
            <p className="mb-4">
                Der Versand meiner Produkte erfolgt innerhalb Deutschlands und Österreichs. Andere Länder auf Anfrage per Angebot.
            </p>

            <h2 className="text-lg font-semibold mt-6 mb-2">Versandkosten</h2>
            <p className="mb-4">
                Die Versandkosten werden im Bestellprozess transparent ausgewiesen.
                Sie richten sich nach Produktgröße, Gewicht und Versandart. <br></br>Die Berechnung kann sich teilweise schwierig gestalten oder unklar sein. Scheuen Sie sich nicht mich persönlich zu kontaktieren für ein Angebot.
            </p>

            <p className="mb-4">
                Alle angegebenen Preise sind Endpreise. Aufgrund der Anwendung der
                Kleinunternehmerregelung gemäß §19 UStG wird keine Umsatzsteuer ausgewiesen.
            </p>

            <h2 className="text-lg font-semibold mt-6 mb-2">Lieferzeit</h2>
            <p className="mb-4">
                Die Lieferzeit beträgt in der Regel <strong>3–7 Werktage</strong>,
                sofern beim jeweiligen Produkt nichts anderes angegeben ist.
            </p>

            <p className="mb-4">
                An Sonn- und Feiertagen erfolgt keine Zustellung.
            </p>

            <h2 className="text-lg font-semibold mt-6 mb-2">Spedition & Paketdienst</h2>
            <p className="mb-4">
                Der Versand erfolgt je nach Produktgröße entweder per Paketdienst
                oder per Spedition. Bei Speditionslieferungen wird vorab ein Liefertermin
                mit Ihnen abgestimmt.
            </p>

            <h2 className="text-lg font-semibold mt-6 mb-2">Selbstabholung</h2>
            <p className="mb-4">
                Eine Selbstabholung ist nach vorheriger Absprache möglich.
                Bitte kontaktieren Sie mich hierzu vor der Bestellung.
            </p>

            <h2 className="text-lg font-semibold mt-6 mb-2">Lieferverzögerungen</h2>
            <p className="mb-4">
                Sollte es in Ausnahmefällen zu Lieferverzögerungen kommen,
                informiere ich Sie umgehend per E-Mail.
            </p>

            <h2 className="text-lg font-semibold mt-6 mb-2">Transportschäden</h2>
            <p className="mb-4">
                Bitte prüfen Sie die Ware bei Anlieferung auf offensichtliche Schäden
                und melden Sie diese umgehend bei mir.
            </p>

            <p className="text-slate-500 text-xs mt-10">
                Stand: {new Date().toLocaleDateString("de-DE")}
            </p>
        </div>
    );
}
